import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert, { AlertColor } from '@mui/material/Alert';

export interface ToastProps {
    open: boolean;
    message: string;
    severity?: AlertColor;
    autoHideDuration?: number;
    onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
}

export const Toast: React.FC<ToastProps> = ({
    open,
    message,
    severity = 'info',
    autoHideDuration = 2000,
    onClose
}) => {
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        onClose(event, reason);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                onClose={handleClose}
                severity={severity}
                sx={{ width: '100%' }}
                variant="filled"
                elevation={6}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};
